import React from 'react';
import { Button, TextField } from '@material-ui/core';
import { DateInput, LinkInput } from './style';
import { ImagePreview, UploadButtonZone, StyledDropzoneArea } from '../AddContracts/style';

const AddBanner = ({ formData, setFormData }) => {
  const imgToBase64 = (file) => {
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        setFormData({
          ...formData,
          img: e.target.result,
        });
        return;
      };
    }
    return;
  };

  return (
    <>
      <TextField
        label="Nome da Campanha"
        fullWidth
        value={formData?.name || ''}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        margin="normal"
        variant="outlined"
      />
      <DateInput
        id="date"
        label="Data de Início"
        type="date"
        onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
        value={formData?.startDate || ''}
        InputLabelProps={{
          shrink: true,
        }}
        margin="normal"
        variant="outlined"
      />
      <DateInput
        id="date"
        label="Data de Término"
        type="date"
        onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
        value={formData?.endDate || ''}
        InputLabelProps={{
          shrink: true,
        }}
        margin="normal"
        variant="outlined"
      />
      <LinkInput
        label="Url da Campanha"
        margin="normal"
        variant="outlined"
        size="medium"
        value={formData?.url || ''}
        onChange={(e) => setFormData({ ...formData, url: e.target.value })}
      />
      <StyledDropzoneArea style={{ paddingLeft: 0 }}>
        <UploadButtonZone item xs={12}>
          <ImagePreview src={formData?.img} />
          <input onChange={(e) => imgToBase64(e.target.files[0])} style={{ display: 'none' }} id="img" accept="image/*" type="file" />
          <br />
          <label htmlFor="img">
            <Button variant="contained" color="primary" component="span">
              Upload
            </Button>
          </label>
        </UploadButtonZone>
      </StyledDropzoneArea>
    </>
  );
};

export default AddBanner;
